import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, ButtonGroup, Button, Form, FormGroup, FormText, Label, Input, FormFeedback } from 'reactstrap';

import { dateIsAfter, dateSub } from '../../../../util/date.js';

import { loginRequest, askLostPasswordRequest, resetPasswordRequest, checkPassword, setUserDateActivity, getUserDateActivity } from '../../UserActions.js';
import { displayErrors } from '../../../Error/ErrorActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import Icon from '../../../../components/Content/Icon.js';

export class UserForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: props.email || '',
            password: '',
            code: props.code || '',
            resetPassword: props.code && props.email,
            isLostPasswordAsked: false,
            isSending: false,
            errorFields: [],
        };
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState(
            { [name]: value },
        );
    };

    handleSubmit = event => {
        event.preventDefault();
        if(this.state.resetPassword) {
            if(this.isValid()) {
                this.setState({ isSending: true });
                this.props.dispatch(resetPasswordRequest(this.state.email.toLowerCase(), this.state.code, this.state.password)).then(result => {
                    this.setState({ isSending: false });
                    if(result) {
                        displayErrors('success', this.props.intl.formatMessage({
                            id: 'userResetPasswordSuccess',
                            defaultMessage: 'Password reset successed!',
                        }));
                        this.props.dispatch(loginRequest(this.state.email, this.state.password)).then(() => {
                            this.props.navigate('/');
                        });
                    } else {
                        displayErrors('error', this.props.intl.formatMessage({
                            id: 'userConfirmationCodeError',
                            defaultMessage: 'Please check your email box to get the confirmation code...',
                        }));
                    }
                });
            } else {
                const errorFields = [];

                if(!this.state.code) {
                    errorFields.push('code');
                } else if(!this.state.password || !checkPassword(this.state.password)) {
                    errorFields.push('password');
                } else if(!this.state.confirmPassword || this.state.password !== this.state.confirmPassword) {
                    errorFields.push('confirmPassword');
                }

                this.setState({ errorFields });
            }
        } else {
            this.setState({
                isSending: true,
            });
            this.props.dispatch(askLostPasswordRequest(this.state.email)).then(result => {
                this.setState({
                    isSending: false,
                });
                if(result) {
                    this.props.dispatch(setUserDateActivity('lostPassword'));
                    this.setState({
                        isLostPasswordAsked: true,
                    });
                    displayErrors('warning', this.props.intl.formatMessage({
                        id: 'userValidForgotPasswordSuccess',
                        defaultMessage: 'Check your email box to use the confirmation code to reset your password!',
                    }));
                } else {
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'userValidForgotPasswordError',
                        defaultMessage: 'Unable to send you a reset password code!',
                    }));
                }
            });
        }
    };

    isValid() {
        return this.state.code && this.state.password && checkPassword(this.state.password) && this.state.confirmPassword === this.state.password;
    }

    hasErrorField(name) {
        return this.state.errorFields && this.state.errorFields.indexOf(name) !== -1;
    }

    render() {
        if(this.state.resetPassword) {
            return (
                <div>
                    {this.state.code && (
                        <FormGroup className="text-center">
                            <Icon icon="info" /> <FormattedMessage id="userResetPasswordInfo2" defaultMessage="Reset your password by filling this fields below:" />
                        </FormGroup>
                    )}
                    <Form onSubmit={this.handleSubmit}>
                        <FormGroup>
                            <Row>
                                <Col sm="6" className={this.hasErrorField('password') ? 'has-danger' : ''}>
                                    <Label for="passwordField"><FormattedMessage id="userPassword" defaultMessage="Password" /></Label>
                                    <Input type="password" name="password" id="passwordField" className={this.hasErrorField('password') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} value={this.state.password} />
                                    <FormText color="muted"><FormattedMessage id="userPasswordRestrictionAlt" defaultMessage="The password must have 6 characters!" /></FormText>
                                    {
                                        this.hasErrorField('password')
                                        ? <FormFeedback><FormattedMessage id="userPasswordError" defaultMessage="Please fill a password!" /></FormFeedback>
                                        : null
                                    }
                                </Col>
                                <Col sm="6" className={this.hasErrorField('confirmPassword') ? 'has-danger' : ''}>
                                    <Label for="confirmPasswordField"><FormattedMessage id="userPasswordConfirmation" defaultMessage="Password confirmation" /></Label>
                                    <Input type="password" name="confirmPassword" id="confirmPasswordField" className={this.hasErrorField('confirmPassword') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} value={this.state.confirmPassword} />
                                    <FormText color="muted"><FormattedMessage id="userPasswordConfirmationRestriction" defaultMessage="This confirmation must be the same of your password" /></FormText>
                                    {
                                        this.hasErrorField('confirmPassword')
                                        ? <FormFeedback><FormattedMessage id="userPasswordConfirmationError" defaultMessage="Please fill a confirmation same as the password field!" /></FormFeedback>
                                        : null
                                    }
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <ButtonGroup className="d-flex">
                                {this.props.closeForm && (
                                    <Button color="light" onClick={this.props.closeForm}>
                                        <Icon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" />
                                    </Button>
                                )}
                                <Button color="warning" className="w-100" disabled={!this.state.password || !this.state.confirmPassword || this.state.isSending} onClick={this.handleSubmit}>
                                    {this.state.isSending ? <Icon icon="spinner" spin /> : <Icon icon="lock" />} <FormattedMessage id="userReInitPassword" defaultMessage="Reset my password" />
                                </Button>
                            </ButtonGroup>
                        </FormGroup>
                    </Form>
                </div>
            );
        }
        if(!this.props.lastRequestDate || dateIsAfter(dateSub('', 5, 'minute'), this.props.lastRequestDate * 1000)) {
            return (
                <Form onSubmit={this.handleSubmit}>
                    <p className="text-center">
                        <Icon icon="info" /> <FormattedMessage id="userResetPasswordInfo3" defaultMessage="Enter your email to reset your password. You will receive an email with instructions for setting your password." />
                    </p>
                    <FormGroup>
                        <Label for="emailField"><FormattedMessage id="userEmail" defaultMessage="Email" /></Label>
                        <Input type="text" name="email" id="emailField" className={this.hasErrorField('email') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder={this.props.intl.messages.userEmail} value={this.state.email} />
                    </FormGroup>
                    <FormGroup>
                        <ButtonGroup className="w-100">
                            {this.props.closeForm ? (
                                <Button color="light" onClick={this.props.closeForm}>
                                    <Icon icon="chevron-left" /> <span className="d-none d-sm-inline"><FormattedMessage id="back" defaultMessage="Back" /></span>
                                </Button>
                            ) : null}
                            <Button color="secondary" disabled={!this.state.email || this.state.isSending} onClick={this.handleSubmit}>
                                {this.state.isSending ? <Icon icon="spinner" spin /> : <Icon icon="lock-unlock" />} <FormattedMessage id="userReInitPassword" defaultMessage="Reset my password" />
                            </Button>
                        </ButtonGroup>
                    </FormGroup>
                </Form>
            );
        }
        return (
            this.state.isLostPasswordAsked
            ? (
                <p className="text-success text-center">
                    <Icon icon="info" /> <FormattedMessage id="userValidForgotPasswordSuccess" defaultMessage="Check your email box to click on the confirmation link!" />
                </p>
            )
            : (
                <p className="text-danger text-center">
                    <Icon icon="danger" /> <FormattedMessage id="userForgotPasswordRetryDateError" defaultMessage="You can not make another forgot password call yet. Please check your email box to get the reset password link." />
                    <br />
                </p>
            )
        );
    }
}

function mapStateToProps(store, props) {
    return {
        lastRequestDate: getUserDateActivity(store, 'lostPassword'),
    };
}

UserForgotPassword.defaultProps = {
    lastRequestDate: '',
    email: '',
    code: '',
    closeForm: null,
};

UserForgotPassword.propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    lastRequestDate: PropTypes.string,
    email: PropTypes.string,
    code: PropTypes.string,
    closeForm: PropTypes.func,
};

export default connect(mapStateToProps)(injectIntl(withRouter(UserForgotPassword)));
